// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CenterOnScreen[data-v-1f1cbed3]{height:380px;left:50%;margin-left:-150px;margin-top:-220px;position:absolute;text-align:center;top:50%;width:300px}.CenterOnScreen h1[data-v-1f1cbed3]{margin-bottom:1rem}.CenterOnScreen p[data-v-1f1cbed3]{text-align:left}", ""]);
// Exports
module.exports = exports;
